import { Checkbox } from 'antd';

export const columns = ({ checkedKeys, onCheck }: any) => {
  const handleCheckChange = (node: { key: string }, checked: boolean) => {
    onCheck(node.key, checked);
  };

  const handleChildrenCheckChange = (node: any, checked: boolean) => {
    if (node.children.length > 0) {
      node.children.map((child: any) => {
        onCheck(child.key, checked);
        handleChildrenCheckChange(child, checked);
      });
    } else {
      return;
    }
  };
  return [
    {
      dataIndex: 'title',
      key: 'title',
      render: (
        _: any,
        node: { key: string; menuName?: string; title?: string; full: boolean },
      ) => (
        <div className="tw-flex tw-items-center">
          <Checkbox
            checked={checkedKeys.includes(node.key)}
            onChange={(e: any) => {
              handleCheckChange(node, e.target.checked);
              handleChildrenCheckChange(node, e.target.checked);
            }}
            style={{ marginRight: '12px', marginLeft: '8px' }}
          />
          <span
            style={{
              minWidth: '150px',
            }}
          >
            {node?.menuName || node?.title}
          </span>
        </div>
      ),
    },
  ];
};
